import React from 'react';
import './App.css';
import Login from './Login';
import LoginCallback from './LoginCallback';
import NotAuthorized from './components/NotAuthorized';
import CustomerRequests from './components/customer-requests/CustomerRequests';
import CustomerRequestDetail from './components/customer-requests/CustomerRequestDetail';
import SlackChannelConfigurations from './components/slack-channel-configurations/SlackChannelConfigurations';
import DriverCoaching from './components/driver-coaching/DriverCoaching';
import ApiKeys from './components/api-keys/ApiKeys';
import SlackChannels from './components/slack-channels/SlackChannels';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';

function Home() {
  const navigate = useNavigate();

  return (
    <main style={{ maxWidth: 700, margin: '2rem auto', padding: '0 1rem' }}>
      <section style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: 32, margin: '1rem 0 0.5rem' }} onClick={() => navigate('/')}>Better Trucks Slack Portal</h1>
        <p style={{ color: '#555', fontSize: 18 }}>
          Manage customer support requests and communicate with customers via Slack.
        </p>
      </section>
    </main>
  );
}

function PrivateRoute({ children }) {
  const { isAuthenticated, hasSlackRole, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasSlackRole) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
}

// Layout for private routes
function MainLayout() {
  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - 75px)' }}>
      <div style={{ flex: 1, overflow: 'auto' }}>
        <Outlet />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/not-authorized" element={<NotAuthorized />} />

          <Route element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/customer-requests" element={<CustomerRequests />} />
            <Route path="/customer-requests/:id" element={<CustomerRequestDetail />} />
            <Route path="/driver-coaching" element={<DriverCoaching />} />
            <Route path="/slack-channel-configurations" element={<SlackChannelConfigurations />} />

            {/* Hidden — not linked from the nav, reachable only by typing the URL */}
            <Route path="/api-keys" element={<ApiKeys />} />
            <Route path="/slack-channels" element={<SlackChannels />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
